import { Platform } from 'react-native'

export const documentTitle = (navText: string, titleText: string) =>
  Platform.select({ web: `${navText} | ${titleText}`, default: titleText })
